import { render, staticRenderFns } from "./EngMainNews.vue?vue&type=template&id=d1fb1b32&"
import script from "./EngMainNews.vue?vue&type=script&lang=js&"
export * from "./EngMainNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports